// extracted by mini-css-extract-plugin
module.exports = {"NotFoundScreen":"NotFoundScreen_NotFoundScreen__3TsOl","Title":"NotFoundScreen_Title__2gqi_","Content":"NotFoundScreen_Content__28SQO"};